import { render, staticRenderFns } from "./FreeTextFieldsConfiguration.vue?vue&type=template&id=abd95874"
import script from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports